import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { forkJoin, pairwise, startWith, Subscription } from "rxjs";
import { generateUUID } from "src/app/core/generators/generateUUID";
import { validarIsNullOrEmpty } from "src/app/core/utils/utilities";
import { TurnoUtils } from "src/app/core/utils/turno.utils";
import {
  ICreateAgendamento,
  IEditAgendamento,
  IGetAgendamentoById,
} from "src/app/services/AgendamentoService/agendamento.model";
import { AgendamentoService } from "src/app/services/AgendamentoService/agendamento.service";
import { IGetCaminhaoResponse } from "src/app/services/CaminhaoService/caminhao.model";
import { CaminhaoService } from "src/app/services/CaminhaoService/caminhao.service";
import { IItems as IItemsCarreta } from "src/app/services/CarretaService/carreta.model";
import { CarretaService } from "src/app/services/CarretaService/carreta.service";
import { IItems as ItemsCavalo } from "src/app/services/CavaloService/cavalo.model";
import { CavaloService } from "src/app/services/CavaloService/cavalo.service";
import { IResponseGetEmpresaById } from "src/app/services/EmpresaService/empresa.model";
import { EmpresaService } from "src/app/services/EmpresaService/empresa.service";
import { ICreateEntradaGate } from "src/app/services/EntradaGateService/entradaGate.model";
import { EntradaGateService } from "src/app/services/EntradaGateService/entradaGate.service";
import { IItems as IItemsMotorista } from "src/app/services/MotoristaService/motorista.model";
import { MotoristaService } from "src/app/services/MotoristaService/motorista.service";
import { IGetPrecoResponse } from "src/app/services/PrecoService/preco.model";
import { PrecoService } from "src/app/services/PrecoService/preco.service";
import { IGetServicoResponse } from "src/app/services/ServicoService/servico.model";
import { ServicoService } from "src/app/services/ServicoService/servico.service";
import { SwalAlertService } from "src/app/services/SwalAlertService/swalAlert.service";
import Swal from "sweetalert2";
import { DestinatarioService } from "src/app/services/DestinatarioService/destinatario.service";
import { IDestinatario } from "src/app/services/DestinatarioService/destinatario.model";
import { CargaService } from "src/app/services/CargaService/carga.service";
import { IGetCarga } from "src/app/services/CargaService/carga.model";
import { TipoCarretaService } from "src/app/services/TipoCarretaService/tipoCarreta.service";
import { IGetTipoCarreta } from "src/app/services/TipoCarretaService/tipoCarreta.model";
import { TransportadoraService } from "src/app/services/TransportadoraService/transportadora.service";
import { IGetTransportadora } from "src/app/services/TransportadoraService/transportadora.model";
import { ClienteService } from "src/app/services/ClienteService/cliente.service";
import { IGetCliente } from "src/app/services/ClienteService/cliente.model";
import { CaixaService } from "src/app/services/CaixaService/caixa.service";
import { JanelaService } from "src/app/services/JanelaService/janela.service";
import { ImpressoraService } from "src/app/services/ImpressoraService/impressora.service";
import { IGetReportBase64 } from "src/app/services/ReportService/report.model";


type IOptions = {
  name: string;
  value: string | number;
  placa?: string;
  listaIndex?: number;
};

@Component({
  selector: "app-cadastro-agendamento",
  templateUrl: "./cadastro-agendamento.component.html",
  styleUrls: ["./cadastro-agendamento.component.scss"],
})
export class CadastroAgendamentoComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  private subscription$ = new Subscription();
  disabledAgendamento: boolean = true;
  visible: boolean = false;
  form: FormGroup;
  title: string = "Cadastro agendamento";
  isLoading: boolean = false;
  guid = generateUUID();
  statusInput: boolean = false;
  statusAgendamentoValue: number = 0;
  motivoCancelamento: string = "";
  activeRoute: string = "";
  idAgendamento: number = 0;
  valorServico: string = "7,00";
  servicoOptions: IOptions[] = [
    {
      name: "",
      value: "",
    },
  ];

  carretaOptions1: IOptions[] = [
    {
      name: "",
      value: "",
    },
  ];

  carretaOptions2: IOptions[] = [
    {
      name: "",
      value: "",
    },
  ];

  carretaOptions3: IOptions[] = [
    {
      name: "",
      value: "",
    },
  ];

  motoristaOptions: IOptions[] = [
    {
      name: "",
      value: "",
    },
  ];

  cavaloOptions: IOptions[] = [
    {
      name: "",
      value: "",
    },
  ];

  copiedCarretaOptions1: IOptions[] = [];
  copiedCarretaOptions2: IOptions[] = [];
  copiedCarretaOptions3: IOptions[] = [];
  valueRemove: IOptions[] = [];
  janelaOptions: IOptions[] = [];
  cargaOptions: IOptions[] = [];
  tipoCarretaOptions: IOptions[] = [];
  transportadoraOptions: IOptions[] = [];
  clienteOptions: IOptions[] = [];
  destinatarioOptions: IOptions[] = [];
  idCaminhao: number = 0;
  turnoLabel: string = "";

  destinatarios: IDestinatario[] = [];
  cargas: IGetCarga[] = [];
  tiposCarreta: IGetTipoCarreta[] = [];
  transportadoras: IGetTransportadora[] = [];
  clientes: IGetCliente[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private agendamentoService: AgendamentoService,
    private servicoService: ServicoService,
    private motoristaService: MotoristaService,
    private cavaloService: CavaloService,
    private carretaService: CarretaService,
    private precoService: PrecoService,
    private empresaService: EmpresaService,
    private caminhaoService: CaminhaoService,
    private entradaGateService: EntradaGateService,
    private swalAlertService: SwalAlertService,
    private destinatarioService: DestinatarioService,
    private cargaService: CargaService,
    private tipoCarretaService: TipoCarretaService,
    private transportadoraService: TransportadoraService,
    private clienteService: ClienteService,
    private caixaService: CaixaService,
    private janelaService: JanelaService,
    private impressoraService: ImpressoraService
  ) {
    this.form = this._inicializarFormulario();
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      FK_SRVC: [0, [Validators.required]],
      DT_AGND: ["", [Validators.required]],
      FK_JNLA: [0, [Validators.required]],
      TURNO: [{ value: "", disabled: true }],
      FK_MTRT_EPSA: [0, [Validators.required]],
      FK_CAVA: [0, [Validators.required]],
      FK_CRRT_1: [0],
      FK_CRRT_2: [0],
      FK_CRRT_3: [0],
      FK_CRGA: [0],
      FK_DTNR: [0],
      FK_TPTD: [0],
      FK_CLNT: [0],
      TX_PLCA_CAVA: [{ value: "", disabled: true }],
      TX_PLCA_CRRT_UNIFICADA: [{ value: "", disabled: true }],
      NM_CRGA: [{ value: "", disabled: true }],
      NM_TIPO_CRRT: [{ value: "", disabled: true }],
      NM_JNLA: [{ value: "", disabled: true }],
      NM_MTRT: [{ value: "", disabled: true }],
      NM_TPTD: [{ value: "", disabled: true }],
      NM_CLNT: [{ value: "", disabled: true }],
      NM_DTNR: [{ value: "", disabled: true }],
      NM_SRVC: [{ value: "", disabled: true }],
      NU_VOLUME: [""],
      TX_CPF: [{ value: "", disabled: true }],
      TX_CNH: [{ value: "", disabled: true }],
      NU_TELE: [{ value: "", disabled: true }],
      TX_OBSV_AGND: [""],
      TX_NOTA_FISCAL: [""],
      NU_PESO_TON: [""],
      TX_CNPJ_TPTD: [{ value: "", disabled: true }],
      TX_CNTT_TPTD: [{ value: "", disabled: true }],
      TX_CNPJ_CLNT: [{ value: "", disabled: true }],
    });
    return form;
  }

  private textoOuTraco(valor: unknown): string {
    if (valor === null || valor === undefined) return "---";
    const texto = String(valor).trim();
    return texto ? texto : "---";
  }

  private nomeOpcao(options: IOptions[], value: unknown, fallback?: string | null): string {
    const id = Number(value);
    if (Number.isFinite(id) && id > 0) {
      const found = options.find((o) => Number(o.value) === id);
      if (found?.name) return found.name;
    }
    return this.textoOuTraco(fallback);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      let status: number = 1;

      if (Object.keys(params).length === 0) {
        status = 1;
      } else {
        this.title = "Editar Agendamento";
        this.disabledAgendamento = false;
        this.visible = true;
        this.idAgendamento = Number(params["codigo"]);
        this.form.get("FK_SRVC")?.disable();

        if (params["modoAgendamento"] == "Visualizar") {
          this.title = "Visualizar Agendamento";
          this.statusInput = true;
          this.form.disable();
          this.disabledAgendamento = true;
          status = 2;
        }
      }

      const observables = [
        this.getServico(status),
        this.getMotorista(status),
        this.getPlacaCavalo(status),
        this.getPlacaCarreta(status),
        this.getDestinatario(),
        this.getCargas(),
        this.getTiposCarreta(),
        this.getTransportadoras(),
        this.getClientes(),
        this.getJanelas(),
      ];

      forkJoin(observables).subscribe(() => {
        this.stateForms();
      });
    });
  }

  ngAfterViewInit(): void {}

  statusAgendamento(): number {
    return 1;
  }

  async stateForms() {
    if (this.idAgendamento === 0) return;

    this.agendamentoService.GetAgendamentoById(this.idAgendamento).subscribe((response: IGetAgendamentoById) => {
      this.statusAgendamentoValue = response.NU_STTS_AGND;
      this.motivoCancelamento = response.TX_MOTV_CNCL_AGND ?? "";
      const isVisualizar = this.title.includes("Visualizar");
      const dtAgnd = response.DT_AGND
        ? isVisualizar
          ? new Date(response.DT_AGND).toLocaleDateString("pt-BR")
          : String(response.DT_AGND)
        : "";
      this.form.controls["DT_AGND"].setValue(dtAgnd);
      this.calcularTurno(String(response.DT_AGND) ?? "");

      this.form.controls["FK_SRVC"].setValue(response.FK_SRVC ?? 0);
      this.form.controls["FK_JNLA"].setValue(response.FK_JNLA ?? 0);
      this.form.controls["TX_OBSV_AGND"].setValue(response.TX_OBSV_AGND ?? "");
      this.form.controls["FK_CRGA"].setValue(response.FK_CRGA ?? 0);
      this.form.controls["FK_DTNR"].setValue(response.FK_DTNR ?? 0);
      this.form.controls["FK_TPTD"].setValue(response.FK_TPTD ?? 0);
      this.form.controls["FK_CLNT"].setValue(response.FK_CLNT ?? 0);

      if (isVisualizar) {
        const janelaFallback =
          response.HR_INIC_JNLA && response.HR_FIM_JNLA
            ? `${response.HR_INIC_JNLA} - ${response.HR_FIM_JNLA}`
            : "";
        this.form.controls["NM_CRGA"].setValue(
          this.nomeOpcao(this.cargaOptions, response.FK_CRGA, response.NM_CRGA)
        );
        this.form.controls["NM_TIPO_CRRT"].setValue(
          this.nomeOpcao(this.tipoCarretaOptions, response.FK_TIPO_CRRT, response.NM_TIPO_CRRT)
        );
        this.form.controls["NM_JNLA"].setValue(
          this.nomeOpcao(this.janelaOptions, response.FK_JNLA, janelaFallback)
        );
        this.form.controls["NM_TPTD"].setValue(
          this.nomeOpcao(this.transportadoraOptions, response.FK_TPTD, response.NM_TPTD)
        );
        this.form.controls["TX_CNPJ_TPTD"].setValue(
          this.textoOuTraco((response as any).TX_CNPJ_TPTD)
        );
        this.form.controls["TX_CNTT_TPTD"].setValue(
          this.textoOuTraco((response as any).TX_CNTT_TPTD)
        );
        this.form.controls["NM_CLNT"].setValue(
          this.nomeOpcao(this.clienteOptions, response.FK_CLNT, response.NM_CLNT)
        );
        this.form.controls["TX_CNPJ_CLNT"].setValue(
          this.textoOuTraco((response as any).TX_CNPJ_CLNT)
        );
        this.form.controls["NM_DTNR"].setValue(
          this.nomeOpcao(this.destinatarioOptions, response.FK_DTNR, response.NM_DTNR)
        );
        this.form.controls["NM_SRVC"].setValue(
          this.nomeOpcao(this.servicoOptions, response.FK_SRVC, response.NM_SRVC)
        );
        this.form.controls["NU_VOLUME"].setValue(this.textoOuTraco(response.NU_VOLUME));
        this.form.controls["TX_NOTA_FISCAL"].setValue(this.textoOuTraco(response.TX_NOTA_FISCAL));
        this.form.controls["NU_PESO_TON"].setValue(this.textoOuTraco(response.NU_PESO_TON));
      } else {
        this.form.controls["NU_VOLUME"].setValue(response.NU_VOLUME ?? "");
        this.form.controls["TX_NOTA_FISCAL"].setValue(response.TX_NOTA_FISCAL ?? "");
        this.form.controls["NU_PESO_TON"].setValue(response.NU_PESO_TON ?? "");
      }

      this.caminhaoService.GetCaminhaoByAgendamento(this.idAgendamento).subscribe((res: IGetCaminhaoResponse) => {
        const idMotorista = res.FK_MTRT_EPSA || res.FK_MTRT_EXTR || 0;
        if (idMotorista !== 0 && res.NM_USUA_MTRT) {
          const motoristaEncontrado = this.motoristaOptions.find((m) => Number(m.value) === Number(idMotorista));
          if (!motoristaEncontrado) {
            this.motoristaOptions = [...this.motoristaOptions, { name: res.NM_USUA_MTRT, value: idMotorista }];
          }
        }

        this.form.controls["FK_MTRT_EPSA"].setValue(idMotorista);
        this.form.controls["FK_CAVA"].setValue(res.FK_CAVA ?? 0);
        this.form.controls["FK_CRRT_1"].setValue(res.FK_CRRT_1 ?? 0);
        this.form.controls["FK_CRRT_2"].setValue(res.FK_CRRT_2 ?? 0);
        this.form.controls["FK_CRRT_3"].setValue(res.FK_CRRT_3 ?? 0);
        this.idCaminhao = Number(res.PK_CMNH);

        if (isVisualizar) {
          this.form.controls["NM_MTRT"].setValue(
            this.nomeOpcao(this.motoristaOptions, idMotorista, res.NM_USUA_MTRT)
          );
          this.form.controls["TX_CPF"].setValue(this.textoOuTraco(res.TX_CPF_MTRT));
          this.form.controls["NU_TELE"].setValue(this.textoOuTraco(res.NU_TELE_MTRT));
          this.form.controls["TX_CNH"].setValue(
            this.textoOuTraco((res as any).TX_CNH_MTRT ?? (res as any).TX_CNH)
          );

          const placaCavalo = (res.TX_PLCA_CAVA || "").toUpperCase().trim();
          this.form.controls["TX_PLCA_CAVA"].setValue(this.textoOuTraco(placaCavalo));

          const placasCarreta = [res.TX_PLCA_CRRT1, res.TX_PLCA_CRRT2, res.TX_PLCA_CRRT3]
            .map((p) => (p || "").toUpperCase().trim())
            .filter((p) => !!p)
            .join(" | ");
          this.form.controls["TX_PLCA_CRRT_UNIFICADA"].setValue(this.textoOuTraco(placasCarreta));
        }

        this.cd.detectChanges();
      });
    });
  }


  createPayload(): ICreateAgendamento | IEditAgendamento {
    return {
      DT_AGND: this.form.controls["DT_AGND"].value,
      NU_STTS_AGND: 1,
      FK_MTRT_EPSA: Number(this.form.controls["FK_MTRT_EPSA"].value),
      FK_CAVA: Number(this.form.controls["FK_CAVA"].value),
      FK_CRRT_1: Number(this.form.controls["FK_CRRT_1"].value),
      FK_CRRT_2: Number(this.form.controls["FK_CRRT_2"].value),
      FK_CRRT_3: Number(this.form.controls["FK_CRRT_3"].value),
      TX_OBSV_AGND: String(this.form.controls["TX_OBSV_AGND"].value),
      FK_SRVC: Number(this.form.controls["FK_SRVC"].value),
      FK_JNLA: Number(this.form.controls["FK_JNLA"].value),
      TX_NOTA_FISCAL: this.form.controls["TX_NOTA_FISCAL"].value ?? "",
      NU_PESO_TON: Number(this.form.controls["NU_PESO_TON"].value) || 0,
      NU_VOLUME: Number(this.form.controls["NU_VOLUME"].value) || 0,
      FK_CRGA: Number(this.form.controls["FK_CRGA"].value) || undefined,
      FK_DTNR: Number(this.form.controls["FK_DTNR"].value) || undefined,
      FK_TPTD: Number(this.form.controls["FK_TPTD"].value) || undefined,
      FK_CLNT: Number(this.form.controls["FK_CLNT"].value) || undefined,
    };
  }

  postarDados() {
    if (this.form.valid) {
      this.isLoading = true;

      let payload = this.createPayload();
      if (this.title.includes("Editar")) {
        payload = {
          ...this.createPayload(),
          FK_CMNH: this.idCaminhao,
        };

        this.agendamentoService.EditarAgendamentoEmpresa(this.idAgendamento, payload).subscribe(
          () => {
            this.router.navigate(["/listagem/agendamento"]);
            this.isLoading = false;
          },
          () => {
            this.isLoading = false;
          },
        );
      } else if (this.title.includes("Cadastro")) {
        this.agendamentoService.CreateAgendamentoEmpresa(payload, this.guid).subscribe(
          (response) => {
            const queryParams = {
              PK_AGND: response.PK_AGND,
            };
            const idEmpresa: number = Number(localStorage.getItem("id"));
            let isFaturado = false;

            this.empresaService.GetEmpresaById(idEmpresa).subscribe((response: IResponseGetEmpresaById) => {
              isFaturado = Boolean(response.FL_FTRD_EPSA);

              if (!isFaturado) {
                this.router.navigate(["pagamento"], {
                  queryParams: queryParams,
                });

                this.swalAlertService.showAlert(
                  "Aten├º├úo",
                  "Agendamento realizado com sucesso, aguardando pagamento.",
                  "info",
                );
              } else {
                this.swalAlertService.showAlertOnConfirmNavigate(
                  "Aten├º├úo",
                  "Agendamento realizado com sucesso.",
                  "success",
                  "listagem/agendamento",
                  true
                );
              }
            });

            this.isLoading = false;
          },
          () => {
            this.isLoading = false;
          },
        );
      }
    } else {
      this.swalAlertService.showAlert(
        "Aten├º├úo",
        "Verifique se todos os campos obrigat├│rios foram preenchidos corretamenta.",
        "warning",
      );
    }
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  async getDestinatario(): Promise<void> {
    try {
      const res: any = await this.destinatarioService.getDestinatarios().toPromise();
      const lista = res?.Destinatarios ?? res?.destinatarios ?? (Array.isArray(res) ? res : []);
      this.destinatarios = lista;
      this.destinatarioOptions = lista.map((d: IDestinatario) => ({
        name: d.NM_DTNR,
        value: d.PK_DTNR,
      }));
    } catch (e) {
      console.error("Erro ao buscar destinatários:", e);
    }
  }

  async getCargas(): Promise<void> {
    try {
      const res: any = await this.cargaService.GetCarga().toPromise();
      const lista: IGetCarga[] = Array.isArray(res) ? res : res?.Cargas ?? res?.cargas ?? [];
      this.cargas = lista;
      this.cargaOptions = lista.map((c) => ({
        name: c.TX_CRGA,
        value: c.PK_CRGA,
      }));
    } catch (e) {
      console.error("Erro ao buscar cargas:", e);
    }
  }

  async getTiposCarreta(): Promise<void> {
    try {
      const res: any = await this.tipoCarretaService.GetTipoCarreta().toPromise();
      const lista: IGetTipoCarreta[] = Array.isArray(res)
        ? res
        : res?.TipoCarretas ?? res?.tipoCarretas ?? [];
      this.tiposCarreta = lista;
      this.tipoCarretaOptions = lista.map((t) => ({
        name: t.NM_TIPO_CRRT,
        value: t.PK_TIPO_CRRT,
      }));
    } catch (e) {
      console.error("Erro ao buscar tipos de carreta:", e);
    }
  }

  async getClientes(): Promise<void> {
    try {
      const res: any = await this.clienteService.GetClientes().toPromise();
      this.clientes = res?.Clientes ?? res?.clientes ?? (Array.isArray(res) ? res : []);
      this.clienteOptions = this.clientes.map((c) => ({
        name: c.NM_CLNT,
        value: c.PK_CLNT,
      }));
    } catch (e) {
      console.error("Erro ao buscar clientes:", e);
    }
  }

  async getTransportadoras(): Promise<void> {
    try {
      const res: any = await this.transportadoraService.GetTransportadoras().toPromise();
      const lista = res?.Transportadoras ?? res?.transportadoras ?? (Array.isArray(res) ? res : []);
      this.transportadoras = lista;
      this.transportadoraOptions = lista.map((t: IGetTransportadora) => ({
        name: t.NM_TPTD,
        value: t.PK_TPTD,
      }));
    } catch (e) {
      console.error("Erro ao buscar transportadoras:", e);
    }
  }

  async getServico(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response: IGetServicoResponse[] = await this.servicoService.GetServico(true).toPromise();

      this.servicoOptions = response.map((x) => ({
        name: x.TX_TIPO_SRVC,
        value: x.PK_SRVC,
      }));
    } catch (error) {
      console.error("Erro ao buscar servi├ºos:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async getMotorista(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.motoristaService.GetMotoristaEmpresa({ paginar: false, status: status }).toPromise();

      this.motoristaOptions = response.ITEMS.map((x: IItemsMotorista) => ({
        name: x.NM_USUA_MTRT,
        value: x.PK_MTRT,
      }));
    } catch (error) {
      console.error("Erro ao buscar motoristas:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async getPlacaCavalo(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.cavaloService.GetCavalo({ paginar: false, status: status, flPtio: true }).toPromise();

      this.cavaloOptions = response.ITEMS.map((x: ItemsCavalo) => ({
        name: x.TX_PLCA_CAVA,
        value: x.PK_CAVA,
      }));
    } catch (error) {
      console.error("Erro ao buscar placas de cavalo:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async getPlacaCarreta(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.carretaService.GetCarreta({ paginar: false, status: status }).toPromise();

      this.carretaOptions1 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT,
      }));
      this.carretaOptions2 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT,
      }));
      this.carretaOptions3 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT,
      }));

      this.copiedCarretaOptions1 = [...this.carretaOptions1];
      this.copiedCarretaOptions2 = [...this.carretaOptions2];
      this.copiedCarretaOptions3 = [...this.carretaOptions3];
    } catch (error) {
      console.error("Erro ao buscar placas de carreta:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async getJanelas(): Promise<void> {
    try {
      const res = await this.janelaService.getJanelas().toPromise();
      if (res) {
        this.janelaOptions = res.map((j) => ({
          name: `${j.HR_INIC} - ${j.HR_FIM}`,
          value: j.PK_JNLA,
        }));
      }
    } catch (e) {
      console.error("Erro ao buscar janelas:", e);
    }
  }

  atualizarCampo(campo: string, valor: any): void {
    if (this.form.controls[campo].value !== valor) {
      this.form.controls[campo].setValue(valor);
    }
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find((opcao) => opcao?.value === Number(value));

    this.atualizarCampo(campo, selecionado?.value);
  }

  escolherServico(value: any): void {
    this.escolherOpcao("FK_SRVC", this.servicoOptions, value);
    this.visible = false;

    if (!validarIsNullOrEmpty(value)) {
      this.precoService.GetPreco({ status: 1, servico: Number(value) }).subscribe((response: IGetPrecoResponse) => {
        const responseValor = response.ITEMS;

        if (responseValor.length == 0) {
          this.swalAlertService.showAlert(
            "Aten├º├úo",
            "Ocorreu uma falha para consultar o valor do servi├ºo, por favor, escolha outra op├º├úo.",
            "warning",
          );
        } else {
          this.visible = true;
          this.valorServico = this.formatarParaReal(String(responseValor[0].VL_SRVC));
        }
      });
    }
  }

  escolherMotorista(value: any): void {
    this.escolherOpcao("FK_MTRT_EPSA", this.motoristaOptions, value);
  }

  escolherPlacaCarreta(value: any, input: number): void {
    const carretasOptions = [this.carretaOptions1, this.carretaOptions2, this.carretaOptions3];

    carretasOptions.forEach((carreta, index) => {
      if (index === input - 1) {
        this.escolherOpcao(`FK_CRRT_${input}`, carreta, value);
      } else {
        this.form.controls[`FK_CRRT_${input}`].valueChanges
          .pipe(startWith(null), pairwise())
          .subscribe(([prev, next]: [any, any]) => {
            const current = carreta.find((opcao) => opcao?.value === Number(next));

            const previous = this.valueRemove.find((opcao) => opcao?.value === Number(prev));

            if (current) {
              const indexToRemove = carreta.indexOf(current);
              if (indexToRemove !== -1) {
                carreta.splice(indexToRemove, 1);
              }
              this.valueRemove.push(current);
            }

            if (previous) {
              const indexToRemove = this.valueRemove.indexOf(previous);
              if (indexToRemove !== -1) {
                this.valueRemove.splice(indexToRemove, 1);
              }
            }
          });
      }
    });
  }

  escolherPlacaCavalo(value: any): void {
    this.escolherOpcao("FK_CAVA", this.cavaloOptions, value);
  }

  formatarParaReal(value: string): string {
    const valueFormate = value.replace(".", ",");

    const partes = valueFormate.split(",");

    const parteInteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const parteDecimal = partes[1] ? `,${partes[1]}` : ",00";

    return `${parteInteira}${parteDecimal}`;
  }

  consultarValor() {
    this.visible = false;

    if (this.form.valid && !this.title.includes("Visualizar")) {
      this.disabledAgendamento = !this.form.valid;
      this.visible = true;
    }
  }

  registrarEntradaGate() {
    if (!this.idAgendamento) return;

    this.isLoading = true;

    this.caixaService.GetCaixaAtual().subscribe({
      next: (caixaRes) => {
        if (!caixaRes || !caixaRes.FL_CAIX_ABRT) {
          this.isLoading = false;
          this.swalAlertService.showAlert(
            "Aten├º├úo",
            "├ë preciso abrir o caixa para registrar a entrada no gate.",
            "info",
            true
          );
          return;
        }

        this.caminhaoService.GetCaminhaoByAgendamento(this.idAgendamento).subscribe({
          next: (res: IGetCaminhaoResponse) => {
            const FK_FUNC_OPER = Number(localStorage.getItem("id"));

            const payload: ICreateEntradaGate = {
              FK_AGND: this.idAgendamento,
              FK_FUNC_OPER: FK_FUNC_OPER,
              NM_USUA_MTRT: res.NM_USUA_MTRT,
              TX_PLCA_CAVA: res.TX_PLCA_CAVA ? res.TX_PLCA_CAVA.toUpperCase() : "",
              TX_PLCA_CRRT1: res.TX_PLCA_CRRT1 ? res.TX_PLCA_CRRT1.toUpperCase() : null,
              TX_PLCA_CRRT2: res.TX_PLCA_CRRT2 ? res.TX_PLCA_CRRT2.toUpperCase() : null,
              TX_PLCA_CRRT3: res.TX_PLCA_CRRT3 ? res.TX_PLCA_CRRT3.toUpperCase() : null,
              TX_OBSV_GATE_ENTR: "",
              FK_CRGA: res.FK_CRGA,
              FK_TIPO_CRRT: res.FK_TIPO_CRRT,
              QT_TOTL_EIXO: res.QT_TOTL_EIXO,
              QT_CPTM: res.QT_CPTM,
            };

            this.entradaGateService.CreateEntradaGate(payload, this.guid).subscribe({
              next: (response) => {
                this.isLoading = false;
                if (response?.PK_GATE_ENTR) {
                  this.imprimirTicketEntrada(response.PK_GATE_ENTR);
                }
                this.swalAlertService.showAlertOnConfirmNavigate(
                  "Sucesso",
                  "Entrada no gate registrada com sucesso.",
                  "success",
                  "listagem/agendamento",
                  true
                );
              },
              error: (err) => {
                this.isLoading = false;
                this.swalAlertService.handleError(err, "Erro", "Não foi possível registrar a entrada no gate.");
              },
            });
          },
          error: (err) => {
            this.isLoading = false;
            this.swalAlertService.handleError(err, "Erro", "N├úo foi poss├¡vel buscar os dados do agendamento.");
          },
        });
      },
      error: (err) => {
        this.isLoading = false;
        if (err.status === 404) {
          this.swalAlertService.showAlert(
            "Aten├º├úo",
            "├ë preciso abrir o caixa para registrar a entrada no gate.",
            "info",
            true
          );
        } else {
          this.swalAlertService.handleError(err, "Erro", "N├úo foi poss├¡vel verificar a situa├º├úo do caixa.");
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {}

  calcularTurno(dataHora: string): void {
    if (!dataHora) {
      this.turnoLabel = "";
      this.form.get("TURNO")?.setValue("");
      return;
    }
    const turno = TurnoUtils.calcularTurno(dataHora);
    this.turnoLabel = turno !== "---" ? turno : "";
    this.form.get("TURNO")?.setValue(this.turnoLabel);
  }

  private imprimirTicketEntrada(idGateEntrada: number): void {
    this.entradaGateService.GetReceiptGateEntradaById(idGateEntrada, 1).subscribe({
      next: (response: IGetReportBase64) => {
        this.impressoraService.impressoraTicket(response.ReportBase64, "text/plain");
      },
      error: () => {
        // Entrada já registrada; falha de impressão não bloqueia o fluxo.
      },
    });
  }
}
